import { StatusBannerProps } from '@izettle/public-site-components/dist/components/sections/shared/status-banner/types'
import { StatusBanner } from '@izettle/public-site-components/dist/help-center'

const StoryInfo: React.FC<{ articleFullSlug: string }> = ({
  articleFullSlug,
}) => {
  const data: StatusBannerProps = {
    _uid: '1',
    component: 'status-banner',
    body: {
      content: `<p>ACTUAL URL: <a href='https://www.zettle.com/${articleFullSlug}' target="_blank">https://www.zettle.com/${articleFullSlug}</a>`,
    },
    ottoIcon: [
      {
        icon: 'IconWarningMedium',
        color: '#000000',
        label: '',
        component: 'otto-icon'
      }
    ],
    layout: [
      {
        backgroundColor: 'salmon-fair',
      },
    ],
  }
  return (
    <div>
      <StatusBanner {...data}></StatusBanner>
    </div>
  )
}

export default StoryInfo
